
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire37b7"];
var parcelRegister = parcelRequire.register;
parcelRegister("fqbXQ", function(module, exports) {

$parcel$export(module.exports, "buildMarketingConsent", function () { return $51ec039540c8cce7$export$689cf67bd4c05bd3; });

var $dBq8m = parcelRequire("dBq8m");
const $51ec039540c8cce7$export$a18e359a3f598d3b = "general consent captured";
const $51ec039540c8cce7$export$689cf67bd4c05bd3 = (config, checkboxState, privacyPolicyText)=>{
    let marketingConsent = null;
    if (config && config.locale) {
        const hasConsent = checkboxState.state !== "not_shown" || config.implicitConsent;
        if (hasConsent) {
            const consent = checkboxState.state === "checked" || config.implicitConsent;
            // @ts-ignore
            const marketingConsentText = checkboxState.consentText || $51ec039540c8cce7$export$a18e359a3f598d3b;
            marketingConsent = {
                consent: consent,
                locale: config.locale,
                marketingConsentText: marketingConsentText
            };
            if (privacyPolicyText) marketingConsent = {
                ...marketingConsent,
                privacyPolicyText: privacyPolicyText
            };
        }
    }
    return marketingConsent;
};
const $51ec039540c8cce7$var$FORCE_SHOW_MARKETING_CONSENT_PARAM = "showMarketingConsent";
const $51ec039540c8cce7$export$44896947615de4a4 = (location)=>{
    const params = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(location.search);
    return $51ec039540c8cce7$var$FORCE_SHOW_MARKETING_CONSENT_PARAM in params;
};

});

parcelRegister("cRW6P", function(module, exports) {

$parcel$export(module.exports, "fetchConsentConfig", function () { return $084060f2cbf1e53b$export$58e2aa80c90a0ce1; });

var $49Pnv = parcelRequire("49Pnv");
const $084060f2cbf1e53b$export$cff006d34f7616ad = (config)=>({
        type: "UPDATE_MARKETING_CONSENT_CONFIG",
        config: config
    });
const $084060f2cbf1e53b$export$58e2aa80c90a0ce1 = (email)=>(dispatch)=>{
        return fetch("/rest/marketing-consent/config", {
            method: "POST",
            credentials: "omit",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: email
            })
        }).then((response)=>{
            if (response.status === 200) return response.json().then((cfg)=>dispatch($084060f2cbf1e53b$export$cff006d34f7616ad(cfg)));
            else if (response.status === 204) {
                // No response from ConsentHub for some reason
                const level = "warning";
                (0, $49Pnv.captureMessage)("Unable to retrieve marketing consent config", {
                    status: response.status,
                    reason: "no_content"
                }, level);
            } else if (response.status === 400) {
                // Signup was unable to extract IP
                const level = "warning";
                (0, $49Pnv.captureMessage)("Unable to retrieve marketing consent config", {
                    status: response.status,
                    reason: "cannot_extract_ip"
                }, level);
            } else return response.text().then((error)=>{
                throw new Error(error || response.statusText);
            });
        }).catch((0, $49Pnv.captureException));
    };

});

parcelRegister("fxz8k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96ac1354dda50b49$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $83IjZ = parcelRequire("83IjZ");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");

var $fqDmW = parcelRequire("fqDmW");

var $leG06 = parcelRequire("leG06");

var $fZMDU = parcelRequire("fZMDU");

var $0wXBc = parcelRequire("0wXBc");
let $96ac1354dda50b49$var$_ = (t)=>t, $96ac1354dda50b49$var$t;
const $96ac1354dda50b49$var$MarketingConsentWrapper = (0, $fqDmW.default).div($96ac1354dda50b49$var$t || ($96ac1354dda50b49$var$t = $96ac1354dda50b49$var$_`
  margin-top: ${0}px;
  div {
    align-items: flex-start;
  }
  [aria-label='checkboxIcon'] {
    margin-left: -8px;
    margin-top: -4px;
  }
  label {
    font-size: 12px;
    line-height: 16px;
    color: ${0};
  }
`), (0, $6e88g.gridSize)(), (0, $kLNLK).N300);
const $96ac1354dda50b49$var$MarketingConsentCheckbox = ({ className: className, config: config, forceShow: forceShow, onConsentChange: onConsentChange })=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const previousConfig = (0, $0wXBc.usePrevious)(config);
    const consentText = formatMessage((0, $fZMDU.default).marketingConsentPromptText);
    const notifyConsentChange = (0, $91i6m.useCallback)(()=>{
        let consent = {
            state: "not_shown"
        };
        if (config && config.showCheckbox) consent = {
            state: "unchecked",
            consentText: consentText
        };
        onConsentChange(consent);
    }, [
        config,
        consentText,
        onConsentChange
    ]);
    (0, $91i6m.useEffect)(()=>{
        notifyConsentChange();
    }, [
        notifyConsentChange
    ]);
    (0, $91i6m.useEffect)(()=>{
        if (previousConfig !== config) notifyConsentChange();
    }, [
        previousConfig,
        config,
        notifyConsentChange
    ]);
    const consentCheckboxChanged = (e)=>{
        const state = e.target.checked ? "checked" : "unchecked";
        onConsentChange({
            state: state,
            consentText: consentText
        });
    };
    if (!config || !config.showCheckbox && !forceShow) return null;
    return /*#__PURE__*/ (0, $4ZSso.jsx)($96ac1354dda50b49$var$MarketingConsentWrapper, {
        className: className,
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $83IjZ.default), {
            testId: "marketing-consent-checkbox",
            id: "marketing-consent-checkbox",
            label: consentText,
            onChange: consentCheckboxChanged
        })
    });
};
var $96ac1354dda50b49$export$2e2bcd8739ae039 = $96ac1354dda50b49$var$MarketingConsentCheckbox;

});
parcelRegister("83IjZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5de0fbd9d160b22e$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $5YM7L = parcelRequire("5YM7L");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $lPOF7 = parcelRequire("lPOF7");

var $koa2c = parcelRequire("koa2c");

var $bb3nf = parcelRequire("bb3nf");

var $kLNLK = parcelRequire("kLNLK");

var $iZbpq = parcelRequire("iZbpq");
var $6tS2B = parcelRequire("6tS2B");
var $bc1Os = parcelRequire("bc1Os");
var $dnhDS = parcelRequire("dnhDS");
var $5de0fbd9d160b22e$var$_excluded = [
    "isChecked",
    "isDisabled",
    "isInvalid",
    "defaultChecked",
    "isIndeterminate",
    "size",
    "onChange",
    "analyticsContext",
    "label",
    "name",
    "value",
    "isRequired",
    "testId",
    "xcss"
];
/* eslint-disable @atlaskit/design-system/no-nested-styles */ var $5de0fbd9d160b22e$var$checkboxStyles = (0, $lPOF7.css)({
    width: "100%",
    height: "100%",
    margin: "var(--ds-space-0, 0px)",
    appearance: "none",
    border: "none",
    gridArea: "1 / 1 / 2 / 2",
    opacity: 0,
    outline: "none",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "& + svg": {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ "--checkbox-background-color": "var(--local-background)",
        "--checkbox-border-color": "var(--local-border)",
        "--checkbox-tick-color": "var(--local-tick-rest)",
        color: "var(--checkbox-background-color)",
        fill: "var(--checkbox-tick-color)",
        gridArea: "1 / 1 / 2 / 2",
        pointerEvents: "none",
        transition: "color 0.2s ease-in-out, fill 0.2s ease-in-out",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "rect:first-of-type": {
            stroke: "var(--checkbox-border-color)",
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: "stroke 0.2s ease-in-out"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&&:focus + svg, &&:checked:focus + svg": {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: "var(--ds-border-width-outline, 2px)".concat(" solid ", "var(--ds-border-focused, ".concat((0, $kLNLK.B200), ")")),
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&:hover + svg": {
        "--checkbox-background-color": "var(--local-background-hover)",
        "--checkbox-border-color": "var(--local-border-hover)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&:checked:hover + svg": {
        "--checkbox-background-color": "var(--local-background-checked-hover)",
        "--checkbox-border-color": "var(--local-border-checked-hover)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&:checked + svg": {
        "--checkbox-background-color": "var(--local-background-checked)",
        "--checkbox-border-color": "var(--local-border-checked)",
        "--checkbox-tick-color": "var(--local-tick-checked)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&[data-invalid] + svg": {
        "--checkbox-border-color": "var(--local-border-invalid)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&:checked[data-invalid] + svg": {
        "--checkbox-border-color": "var(--local-border-checked-invalid)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&:active + svg": {
        "--checkbox-background-color": "var(--local-background-active)",
        "--checkbox-border-color": "var(--local-border-active)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&:checked:active + svg": {
        "--checkbox-background-color": "var(--local-background-active)",
        "--checkbox-border-color": "var(--local-border-active)",
        "--checkbox-tick-color": "var(--local-tick-active)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg": {
        "--checkbox-background-color": "var(--local-background-disabled)",
        "--checkbox-border-color": "var(--local-border-disabled)",
        cursor: "not-allowed",
        pointerEvents: "none"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&:disabled:checked + svg": {
        "--checkbox-tick-color": "var(--local-tick-disabled)"
    },
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "& + svg": {
            "--checkbox-background-color": "Canvas",
            "--checkbox-border-color": "CanvasText",
            "--checkbox-tick-color": "CanvasText"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&:checked + svg, &:checked:hover + svg": {
            "--checkbox-background-color": "Canvas",
            "--checkbox-border-color": "CanvasText",
            "--checkbox-tick-color": "CanvasText"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "&:focus + svg rect:first-of-type": {
            stroke: "Highlight"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&[data-invalid] + svg": {
            "--checkbox-border-color": "Highlight"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&:checked[data-invalid] + svg": {
            "--checkbox-border-color": "Highlight"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg": {
            "--checkbox-background-color": "Canvas",
            "--checkbox-border-color": "GrayText",
            "--checkbox-tick-color": "GrayText"
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ var $5de0fbd9d160b22e$var$Checkbox = /*#__PURE__*/ (0, $91i6m.memo)(/*#__PURE__*/ (0, $91i6m.forwardRef)(function Checkbox(props, ref) {
    var isCheckedProp = props.isChecked, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$defaultChecked = props.defaultChecked, defaultChecked = _props$defaultChecked === void 0 ? false : _props$defaultChecked, _props$isIndeterminat = props.isIndeterminate, isIndeterminate = _props$isIndeterminat === void 0 ? false : _props$isIndeterminat, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, onChangeProps = props.onChange, analyticsContext = props.analyticsContext, label = props.label, name = props.name, value = props.value, isRequired = props.isRequired, testId = props.testId, xcss = props.xcss, rest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(props, $5de0fbd9d160b22e$var$_excluded);
    var _useState = (0, $91i6m.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useState, 2), isCheckedState = _useState2[0], setIsCheckedState = _useState2[1];
    var onChange = (0, $91i6m.useCallback)(function(e, analyticsEvent) {
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    var onChangeAnalytics = (0, $koa2c.usePlatformLeafEventHandler)({
        fn: onChange,
        action: "changed",
        analyticsData: analyticsContext,
        componentName: "checkbox",
        packageName: "@atlaskit/checkbox",
        packageVersion: "13.5.2"
    });
    var internalRef = (0, $91i6m.useRef)(null);
    var mergedRefs = (0, $bb3nf.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    var isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    return (0, $lPOF7.jsx)((0, $6tS2B.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? "".concat(rest.id, "-label") : undefined,
        testId: testId && "".concat(testId, "--checkbox-label"),
        xcss: xcss
    }, (0, $lPOF7.jsx)("input", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0
    }, rest, {
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $5de0fbd9d160b22e$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-checked": isIndeterminate ? "mixed" : isChecked,
        "aria-invalid": isInvalid ? "true" : undefined,
        "data-testid": testId && "".concat(testId, "--hidden-checkbox"),
        "data-invalid": isInvalid ? "true" : undefined
    })), (0, $lPOF7.jsx)((0, $iZbpq.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && (0, $lPOF7.jsx)((0, $bc1Os.default), null, label, isRequired && (0, $lPOF7.jsx)((0, $dnhDS.default), null)));
}));
$5de0fbd9d160b22e$var$Checkbox.displayName = "Checkbox";
var $5de0fbd9d160b22e$export$2e2bcd8739ae039 = $5de0fbd9d160b22e$var$Checkbox;

});
parcelRegister("iZbpq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd26c6167f7efb94$export$2e2bcd8739ae039; });
/**  @jsx jsx */ 
var $91i6m = parcelRequire("91i6m");

var $lPOF7 = parcelRequire("lPOF7");

var $3erT1 = parcelRequire("3erT1");
function $dd26c6167f7efb94$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return (0, $lPOF7.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return (0, $lPOF7.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ var $dd26c6167f7efb94$var$CheckboxIcon = /*#__PURE__*/ (0, $91i6m.memo)(function(_ref) {
    var size = _ref.size, isIndeterminate = _ref.isIndeterminate, isChecked = _ref.isChecked;
    var icon = (0, $91i6m.useMemo)(function() {
        return $dd26c6167f7efb94$var$getIcon(isIndeterminate, isChecked);
    }, [
        isIndeterminate,
        isChecked
    ]);
    return (0, $lPOF7.jsx)((0, $3erT1.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, (0, $lPOF7.jsx)("g", {
        fillRule: "evenodd"
    }, (0, $lPOF7.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $dd26c6167f7efb94$export$2e2bcd8739ae039 = $dd26c6167f7efb94$var$CheckboxIcon;

});
parcelRegister("3erT1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25a84f8d7c2458dd$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $91i6m = parcelRequire("91i6m");

var $lPOF7 = parcelRequire("lPOF7");

var $g4s81 = parcelRequire("g4s81");

var $3mkri = parcelRequire("3mkri");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $25a84f8d7c2458dd$var$svgStyles = (0, $lPOF7.css)((0, $3mkri.commonSVGStyles));
/**
 * __SVG__
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
 */ var $25a84f8d7c2458dd$var$SVG = /*#__PURE__*/ (0, $91i6m.memo)(function SVG(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? "medium" : _ref$size, label = _ref.label, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, testId = _ref.testId, children = _ref.children;
    return (0, $lPOF7.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fill: secondaryColor || (0, $g4s81.getBackground)()
        },
        css: [
            $25a84f8d7c2458dd$var$svgStyles,
            (0, $3mkri.sizeStyleMap)[size]
        ],
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? "img" : "presentation"
    }, children);
});
var $25a84f8d7c2458dd$export$2e2bcd8739ae039 = $25a84f8d7c2458dd$var$SVG;

});


parcelRegister("6tS2B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0137bb567be00b22$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lPOF7 = parcelRequire("lPOF7");

var $kLNLK = parcelRequire("kLNLK");
var $0137bb567be00b22$var$baseStyles = (0, $lPOF7.css)({
    display: "grid",
    gridAutoColumns: "1fr",
    gridAutoRows: "min-content",
    color: "var(--ds-text, ".concat((0, $kLNLK.N900), ")"),
    cursor: "default",
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
});
var $0137bb567be00b22$var$textLabelLayoutStyles = (0, $lPOF7.css)({
    gap: "var(--ds-space-0, 0px)".concat(" ", "var(--ds-space-050, 4px)"),
    gridTemplateColumns: "min-content auto"
});
var $0137bb567be00b22$var$disabledStyles = (0, $lPOF7.css)({
    color: "var(--ds-text-disabled, ".concat((0, $kLNLK.N80), ")"),
    cursor: "not-allowed"
});
var $0137bb567be00b22$var$labelStyles = (0, $lPOF7.css)({
    /**
   * Background
   */ "--local-background": "var(--ds-background-input, ".concat((0, $kLNLK.N10), ")"),
    "--local-background-active": "var(--ds-background-input-pressed, ".concat((0, $kLNLK.B50), ")"),
    "--local-background-checked": "var(--ds-background-selected-bold, ".concat((0, $kLNLK.B400), ")"),
    "--local-background-checked-hover": "var(--ds-background-selected-bold-hovered, ".concat((0, $kLNLK.B300), ")"),
    "--local-background-disabled": "var(--ds-background-disabled, ".concat((0, $kLNLK.N20), ")"),
    "--local-background-hover": "var(--ds-background-input-hovered, ".concat((0, $kLNLK.N30), ")"),
    /**
   * Border
   */ "--local-border": "var(--ds-border-input, ".concat((0, $kLNLK.N100), ")"),
    "--local-border-active": "var(--ds-border, ".concat((0, $kLNLK.B50), ")"),
    "--local-border-checked": "var(--ds-background-selected-bold, ".concat((0, $kLNLK.B400), ")"),
    "--local-border-checked-hover": "var(--ds-background-selected-bold-hovered, ".concat((0, $kLNLK.B300), ")"),
    "--local-border-checked-invalid": "var(--ds-border-danger, ".concat((0, $kLNLK.R300), ")"),
    "--local-border-disabled": "var(--ds-background-disabled, ".concat((0, $kLNLK.N20), ")"),
    "--local-border-focus": "var(--ds-border-focused, ".concat((0, $kLNLK.B200), ")"),
    "--local-border-hover": "var(--ds-border-input, ".concat((0, $kLNLK.N100), ")"),
    "--local-border-invalid": "var(--ds-border-danger, ".concat((0, $kLNLK.R300), ")"),
    /**
   * Tick
   */ "--local-tick-active": "var(--ds-icon-inverse, ".concat((0, $kLNLK.B400), ")"),
    "--local-tick-checked": "var(--ds-icon-inverse, ".concat((0, $kLNLK.N10), ")"),
    "--local-tick-disabled": "var(--ds-icon-disabled, ".concat((0, $kLNLK.N70), ")"),
    "--local-tick-rest": "transparent"
});
function $0137bb567be00b22$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, testId = _ref.testId, label = _ref.label, id = _ref.id, xcss = _ref.xcss;
    return (0, $lPOF7.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $0137bb567be00b22$var$baseStyles,
            label && $0137bb567be00b22$var$textLabelLayoutStyles,
            isDisabled && $0137bb567be00b22$var$disabledStyles,
            $0137bb567be00b22$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("bc1Os", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $826238b3ba55723d$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lPOF7 = parcelRequire("lPOF7");
var $826238b3ba55723d$var$labelTextStyles = (0, $lPOF7.css)({
    alignSelf: "center",
    gridArea: "1 / 2 / 2 / 3"
});
function $826238b3ba55723d$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return (0, $lPOF7.jsx)("span", {
        css: $826238b3ba55723d$var$labelTextStyles
    }, children);
}

});

parcelRegister("dnhDS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9bcb1bbabfc1e798$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lPOF7 = parcelRequire("lPOF7");

var $kLNLK = parcelRequire("kLNLK");
var $9bcb1bbabfc1e798$var$requiredIndicatorStyles = (0, $lPOF7.css)({
    color: "var(--ds-text-danger, ".concat((0, $kLNLK.R500), ")"),
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $9bcb1bbabfc1e798$export$2e2bcd8739ae039() {
    return (0, $lPOF7.jsx)("span", {
        css: $9bcb1bbabfc1e798$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});


parcelRegister("fZMDU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23852cbaf3eed85c$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $23852cbaf3eed85c$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    marketingConsentPromptText: {
        id: "marketing.consent.text",
        defaultMessage: "Yes! Send me news and offers from Atlassian about products, events, and more.",
        description: ""
    }
});

});



//# sourceMappingURL=page.cc4ab7f8.js.map
